export const TOTAL_NET_WORTH_OPTIONS = [
  {
    text: '<$200k',
    value: '<$200k',
    messageIcon: 'exclamation',
    message: 'Because these offerings are private placements of securities that are somewhat illiquid in nature, you must have a minimum net worth of at least $200k.',
  },
  {
    text: '$200k – $1MM',
    value: '$200k – $1MM',
  },
  {
    text: '$1MM – $5MM',
    value: '$1MM – $5MM',
  },
  {
    text: '>$5MM',
    value: '>$5MM',
  },
];

export const LIQUID_WORTH_OPTIONS = [
  {
    text: '<$50k',
    value: '<$50k',
    messageIcon: 'exclamation',
    message: 'Your estimated liquid net worth is below the threshold we consider suitable for investors in offerings on the Platform.',
  },
  {
    text: '$50k – $250k',
    value: '$50k – $250k',
  },
  {
    text: '$250k – $1MM',
    value: '$250k - $1MM',
  },
  {
    text: '>$1MM',
    value: '>$1MM',
  },
];

export const ANNUAL_INCOME_OPTIONS = [
  {
    text: '<$200k',
    value: '<$200k',
  },
  {
    text: '$200k – $1MM',
    value: '$200k – $1MM',
  },
  {
    text: '$1MM – $5MM',
    value: '$1MM – $5MM',
  },
  {
    text: '>$5MM',
    value: '>$5MM',
  },
];
